import { Badge, Text, Link, VStack } from "@postenbring/hedwig-react";

const HitContentRegular = ({hit, hitIndex, localization}) => (
    <VStack gap="8" align="flex-start">
        <Badge size="smaller">{localization.categoryContentLabel}</Badge>
        <Text variant='h3' as='h2' id={"hit-" + hitIndex}>
            {hit.heading}
        </Text>
        <Text asChild id={"hitContent-" + hitIndex}>
            <p dangerouslySetInnerHTML={{__html: hit.preface}}/>
        </Text>
        <Link href={hit.absoluteUrl} aria-label={hit.heading} aria-describedby={"hitContent-" + hitIndex}>
            {hit.absoluteUrl}
        </Link>
    </VStack>
);

const HitContentMedia = ({ hit, hitIndex, localization }) => (
    <VStack gap="8" align="flex-start">
        <Badge size='smaller'>{localization.mediaDocumentLabel}</Badge>
        <Text variant='h3' as='h2' id={"hit-" + hitIndex}>
            {hit.heading}
        </Text>
        <Link href={hit.absoluteUrl} aria-describedby={'hit-' + hitIndex} target="_blank">
            {localization.openNewWindow}
        </Link>
    </VStack>
);


const HitContent = ({hit, hitIndex, localization}) => {
    return hit._type == 'media:document' ?
        <HitContentMedia localization={localization} hit={hit} hitIndex={hitIndex}/> :
        <HitContentRegular localization={localization} hit={hit} hitIndex={hitIndex}/>;
};

export default HitContent;
